import React from "react";

export const toCategorySlug = (text) =>
  console.log('text', text) ||
  text
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "");
    
export const toSubCategorySlug = (text) =>
  text
    .toLowerCase()
    .trim()
    .replace(/\//g, "-")
    .replace(/\s+/g, "-")
    .replace(/-*&-*/g, "-&-")
    .replace(/-+/g, "-"); 

export const toServiceNameSlug = (text) =>
  text
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-*&-*/g, "-&-");
    
export const toProNameSlug = (text) =>
  text
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-*&-*/g, "-&-");

export const slugToCatName = (slug = "") =>
    slug
        .split("-")
        .map(
        word => word.charAt(0).toUpperCase() + word.slice(1)
        )
        .join(" ");

export const slugToSubCatName = (slug = "") =>
    slug
        .split("/")
        .map(part => {
        const words = part.split("-");

        // Special case: de-tan
        if (words.length === 2 && words[0] === "de") {
            return "De-Tan";
        }

        // Normal case
        return words
            .map(w => w.charAt(0).toUpperCase() + w.slice(1))
            .join(" ");
        })
        .join("/");